module.exports = __webpack_public_path__ + "img/t_advdemo.67f4869a.gif";